/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconDiamonds: {
  name: 'diamonds';
  data: string;
} = {
  name: 'diamonds',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M307.451 104.172 470.992 305.33 307.451 506.487l-163.54-201.158 163.54-201.157z"/></svg>`,
};
